const confirmPasswordResources = {
    labelNewPasword: 'New Password',
    labelPassword: 'Password',
    labelConfirmPassword: 'Confirm Password',
};
export default confirmPasswordResources;
